import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router';
import { appRouters, appMobileRouters } from './app';
import { isMobile } from '@/utils/common';
// import LoginView from '../views/login/LoginView.vue'
// import CodeView from '../views/CodeView.vue'
// import ErrorView from '@/views/ErrorView.vue'

// const SUFFIX_CLIENT_ID = {

//   'RA': 'b85b0883-3ecb-bbae-7434-6a7742a53eef'

// };
// const isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);

const pcRoutes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/LoginView.vue'),
    props: false
    
  },
  {
    path: '/regist',
    name: 'regist',
    component: () => import('@/views/regist/RegistView.vue'),
    props: false,
    meta: { backgroundClass: 'regist-bg' }

  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },
  // {
  //   path: '/',
  //   name: 'main',
  //   component: () => import('@/views/MainView'),
  //   props: true
  // },
 
  // {
  //   path: '/wf/:code?',
  //   name: 'WorkflowMain',
  //   component: () => import('@/views/MainView'),
  //   props: true
  // }, 
  // {
  //   path: '/:suffix',
  //   name: 'main',
  //   component: () => import('@/views/MainView'),
  //   props: true
  // },  
  {
    path: '/',
    name: 'main',
    component: () => import('@/views/code/CodeView.vue'),
    props: true
  },
  {
    path: '/note',
    name: 'note',
    component: () => import('@/views/note/NoteView'),
    props: true
  },
  {
    path: '/registSuccess',
    name: 'registSuccess',
    meta: {
      title: 'regist.success'
    },
    component: () => import('@/views/registSuccess/RegistSuccess.vue'),
    props: true
  },
  {
    path: '/error',
    name: 'error',
    component: () => import('@/views/ErrorView'),
  },
  ...appRouters,
  { path: '/:pathMatch(.*)*', redirect: '/error' }
];

const mobileRoutes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/LoginView-mobile.vue'),
    meta: {
      title: 'login.title'
    },
    props: false

  },
  {
    path: '/regist',
    name: 'regist',
    // title: this.$t('regist.title'),
    meta: {
      title: 'regist.title'
    },
    component: () => import('@/views/regist/RegistView-mobile.vue'),
    props: false

  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/',
    name: 'main',
    meta: {
      title: 'codeView.title'
    },
    component: () => import('@/views/code/CodeView-mobile.vue'),
    props: true
  },

  // {
  //   path: '/wf/:code?',
  //   name: 'WorkflowMain',
  //   component: () => import('@/views/MainView'),
  //   props: true
  // }, 
  // {
  //   path: '/:suffix',
  //   name: 'main',
  //   component: () => import('@/views/MainView'),
  //   props: true
  // },  
  // {
  //   path: '/code',
  //   name: 'code',
  //   meta: {
  //     title: 'codeView.title'
  //   },
  //   component: () => import('@/views/code/CodeView-mobile.vue'),
  //   props: true
  // },
  {
    path: '/note',
    name: 'note',
    meta: {
      title: 'noteView.success'
    },
    component: () => import('@/views/note/NoteView-mobile.vue'),
    props: true
  },
  {
    path: '/registSuccess',
    name: 'registSuccess',
    meta: {
      title: 'regist.success'
    },
    component: () => import('@/views/registSuccess/RegistSuccess-mobile.vue'),
    props: true
  },
  {
    path: '/error',
    name: 'error',
    meta: {
      title: 'codeView.title'
    },
    component: () => import('@/views/ErrorView'),
  },
  ...appMobileRouters,
  { path: '/:pathMatch(.*)*', redirect: '/error' }
]

const routes = isMobile ? mobileRoutes : pcRoutes
const router = createRouter({
  history: process.env.VUE_APP_ROUTER_HISTORY == 'hash' ?
    createWebHashHistory(process.env.BASE_URL) : createWebHistory(process.env.BASE_URL),
    routes    
})

export default router
